import createReducer from '../utils/createReducer';
import {
  CUSTOM_OPTIONS_REQUEST,
  CUSTOM_OPTIONS_SUCCESS,
  CUSTOM_OPTIONS_FAILURE,
} from '../constants/actions';

const initialState = {
  isError: false,
  statusText: null,
  data: [],
  token: null,
};

export default createReducer(initialState, {
  [CUSTOM_OPTIONS_REQUEST]: state => (
    Object.assign({}, state, {
      isError: false,
    })
  ),
  [CUSTOM_OPTIONS_SUCCESS]: (state, payload) => (
    Object.assign({}, state, {
      data: payload.data ? [].concat(payload.data) : [],
      token: payload.token,
    })
  ),
  [CUSTOM_OPTIONS_FAILURE]: (state, payload) => (
    Object.assign({}, state, {
      isError: true,
      statusText: payload.message,
    })
  ),
});



// WEBPACK FOOTER //
// ./src/reducers/customOptions.js